export default function ({ item, isLoading }) {
  if (isLoading) return 'loading';
  return (
    <p className="flex-row">
      {item.animal.type.map((animal) => animal.value).join(', ')}
    </p>
  );
}
